export const paths = {
	HOME: '/',
	LOGIN: '/login',
	REGISTER: '/register',
	DASHBOARD: '/dashboard',
	CREDIT_CHECK: '/credit-check',
	DEBTS: '/debts',
	API_KEYS: '/api-keys',
	NOTIFICATIONS: '/notifications',
	INSTITUTIONS: '/institutions',
	PROFILE: '/profile',
	CATCH_ALL: '*',
};
